import { createAction } from 'redux-actions';

export const loadGetUserProfile = createAction('LOAD_GET_USER_PROFILE');
export const loadedGetUserProfile = createAction('LOADED_GET_USER_PROFILE');
export const errorGetUserProfile = createAction('ERROR_GET_USER_PROFILE');
export const clearGetUserProfile = createAction('CLEAR_GET_USER_PROFILE');
